/* aviaf — shared mock data */

window.ACCOUNTS = [
  { id:"c1", broker:"TopstepX", kind:"live", code:"TSX-100", label:"Combine 150K · #1",
    equity:158420.50, dayStart:156320.00, sessionStart:150000.00,
    dayPnl:2100.50, totalPnl:8420.50, target:9000, mllFloor:145500, openedAt:"2026-03-12",
    instance:"inst-01" },
  { id:"c2", broker:"TopstepX", kind:"paper", code:"TSX-PAPER", label:"Paper · alpha-driven",
    equity:152480.20, dayStart:152780.00, sessionStart:150000.00,
    dayPnl:-299.80, totalPnl:2480.20, target:9000, mllFloor:145500, openedAt:"2026-02-28",
    instance:"inst-02" },
  { id:"x1", broker:"TopstepX", kind:"xfa", code:"XFA-50K", label:"XFA · grind mode",
    equity:50880.00, dayStart:50836.00, sessionStart:50000.00,
    dayPnl:44.00, totalPnl:880.00, target:0, mllFloor:47500, openedAt:"2026-04-01",
    instance:"inst-03" },
  { id:"c3", broker:"TopstepX", kind:"live", code:"TSX-101", label:"Combine 150K · #2",
    equity:146280.00, dayStart:148120.00, sessionStart:150000.00,
    dayPnl:-1840.00, totalPnl:-3720.00, target:9000, mllFloor:145500, openedAt:"2026-03-20",
    instance:"inst-04" },
];

/* configs — bind strategies + risk + account into a runnable snapshot */
window.CONFIGS = [
  { id:"cfg-mgc-alpha", file:"mgc_1h_alpha_20260402.toml", label:"MGC Alpha 1h", note:"single-strategy · MGC.M26 · 2c · ATR sized",
    strategyDefs:["sd-mgc-alpha"], dailyLossCap:1500, maxConcurrent:2, lastEdit:"2026-04-02", usedBy:["inst-02"] },
  { id:"cfg-nq-orb", file:"nq_5m_orb_20260403.toml", label:"NQ ORB 5m", note:"single-strategy · NQ.M26 · 1c",
    strategyDefs:["sd-nq-orb"], dailyLossCap:2000, maxConcurrent:1, lastEdit:"2026-04-03", usedBy:["inst-04"] },
  { id:"cfg-combo", file:"combined_mgc1h_nq5m_20260402.toml", label:"Combined MGC + NQ", note:"shared $2k DLC · MGC 1c + NQ 1c",
    strategyDefs:["sd-mgc-alpha","sd-nq-orb"], dailyLossCap:2000, maxConcurrent:2, lastEdit:"2026-04-02", usedBy:["inst-01"] },
  { id:"cfg-grind", file:"m2k_1h_alpha_20260402.toml", label:"MGC 1c grind (XFA)", note:"survival mode · 1c · risk $350",
    strategyDefs:["sd-mgc-grind"], dailyLossCap:600, maxConcurrent:1, lastEdit:"2026-04-02", usedBy:["inst-03"] },
];

/* strategy DEFINITIONS — abstract recipe (research artifact). distinct from running attachments */
window.STRATEGY_DEFS = [
  { id:"sd-mgc-alpha", name:"MGC Alpha 1h", family:"alpha-driven", symbol:"MGC", venue:"COMEX",
    author:"k.s.", validated:"2026-04-02", basis:"r-001 · r-005 · r-008",
    summary:"Momentum z-score on 1h MGC bars; ATR-sized 2c; 2-bar persistence; max 2 SL/day.",
    keyParams:{momentum_lookback:20, alpha_threshold:0.015, sl_pct:0.006, tp_pct:0.018},
    bench:{wr:0.482, pf:1.68, eR:0.352, ppass:0.163, pruin:0.273} },
  { id:"sd-nq-orb", name:"NQ ORB 5m", family:"opening-range-breakout", symbol:"NQ", venue:"CME",
    author:"k.s.", validated:"2026-04-03", basis:"r-002 · r-003",
    summary:"30-min opening range breakout on NQ 5m; 2-tick buffer; 1:3 ATR-based stop.",
    keyParams:{opening_range_minutes:30, breakout_buffer_ticks:2, sl_atr_mult:1.0, tp_atr_mult:3.0},
    bench:{wr:0.520, pf:2.04, eR:0.612, ppass:0.788, pruin:0.874} },
  { id:"sd-mgc-grind", name:"MGC 1c grind", family:"alpha-driven", symbol:"MGC", venue:"COMEX",
    author:"k.s.", validated:"2026-04-02", basis:"r-001",
    summary:"MGC alpha at 1c with reduced risk ($350/trade) — survival-only XFA mode.",
    keyParams:{momentum_lookback:20, alpha_threshold:0.015, sl_pct:0.006, contracts:1},
    bench:{wr:0.566, pf:1.41, eR:0.221, ppass:0.005, pruin:0.008} },
];

/* runtime attachments — strategy def × instance × account, with live perf */
window.STRATS = [
  { id:"mgc-alpha-c1", defId:"sd-mgc-alpha", name:"MGC Alpha 1h", symbol:"MGC", venue:"COMEX",
    acct:"c1", instance:"inst-01", state:"running", type:"alpha_driven",
    contracts:2, riskPerTrade:700, since:"08:14 CT", lastSig:"+2 long",
    wr:0.482, pf:1.68, eR:0.352, trades:56, pnl30:1842.20, today:615.00, dd:-1230, n:56,
    sharpe:1.42, sortino:1.81, avgHold:"1.4h" },
  { id:"nq-orb-c1", defId:"sd-nq-orb", name:"NQ ORB 5m", symbol:"NQ", venue:"CME",
    acct:"c1", instance:"inst-01", state:"armed", type:"orb",
    contracts:1, riskPerTrade:1815, since:"08:32 CT", lastSig:"TP hit",
    wr:0.520, pf:2.04, eR:0.612, trades:22, pnl30:4188.00, today:1485.50, dd:-2960, n:22,
    sharpe:1.96, sortino:2.42, avgHold:"0.7h" },
  { id:"mgc-alpha-c2", defId:"sd-mgc-alpha", name:"MGC Alpha 1h", symbol:"MGC", venue:"COMEX",
    acct:"c2", instance:"inst-02", state:"running", type:"alpha_driven",
    contracts:2, riskPerTrade:700, since:"00:01 CT", lastSig:"-1 short",
    wr:0.461, pf:1.55, eR:0.298, trades:41, pnl30:980.40, today:-299.80, dd:-880, n:41,
    sharpe:1.18, sortino:1.42, avgHold:"1.6h" },
  { id:"mgc-grind-x1", defId:"sd-mgc-grind", name:"MGC 1c grind", symbol:"MGC", venue:"COMEX",
    acct:"x1", instance:"inst-03", state:"running", type:"alpha_driven",
    contracts:1, riskPerTrade:350, since:"07:51 CT", lastSig:"scratch",
    wr:0.566, pf:1.41, eR:0.221, trades:32, pnl30:1208.00, today:44.00, dd:-540, n:32,
    sharpe:1.04, sortino:1.28, avgHold:"1.2h" },
  { id:"nq-orb-c3", defId:"sd-nq-orb", name:"NQ ORB 5m", symbol:"NQ", venue:"CME",
    acct:"c3", instance:"inst-04", state:"paused", type:"orb",
    contracts:1, riskPerTrade:1815, since:"08:46 CT", lastSig:"SL guard",
    wr:0.413, pf:1.12, eR:0.108, trades:19, pnl30:-742.00, today:-1840.00, dd:-4704, n:19,
    sharpe:0.42, sortino:0.51, avgHold:"0.9h" },
  { id:"mgc-alpha-c3", defId:"sd-mgc-alpha", name:"MGC Alpha 1h", symbol:"MGC", venue:"COMEX",
    acct:"c3", instance:"inst-04", state:"stopped", type:"alpha_driven",
    contracts:0, riskPerTrade:700, since:"—", lastSig:"off",
    wr:0.402, pf:0.94, eR:-0.041, trades:14, pnl30:-612.00, today:0, dd:-915, n:14,
    sharpe:-0.12, sortino:-0.18, avgHold:"1.5h" },
];

/* aviaf processes */
window.INSTANCES = [
  { id:"inst-01", host:"aviaf-live-01", pid:18432, account:"c1", config:"cfg-combo",
    started:"2026-05-05 08:14 CT", uptime:"06h 12m", state:"running",
    cpu:4.2, mem:312, py:"3.11.7", branch:"main@a3f8c21", ticksPerSec:142, lagMs:38,
    strategies:["mgc-alpha-c1","nq-orb-c1"], heartbeat: gen_heartbeat(1) },
  { id:"inst-02", host:"aviaf-paper",   pid:9821,  account:"c2", config:"cfg-mgc-alpha",
    started:"2026-05-05 00:01 CT", uptime:"14h 25m", state:"running",
    cpu:1.8, mem:244, py:"3.11.7", branch:"main@a3f8c21", ticksPerSec:88, lagMs:42,
    strategies:["mgc-alpha-c2"], heartbeat: gen_heartbeat(2) },
  { id:"inst-03", host:"aviaf-live-01", pid:18510, account:"x1", config:"cfg-grind",
    started:"2026-05-05 07:51 CT", uptime:"06h 35m", state:"running",
    cpu:1.4, mem:198, py:"3.11.7", branch:"main@a3f8c21", ticksPerSec:64, lagMs:36,
    strategies:["mgc-grind-x1"], heartbeat: gen_heartbeat(3) },
  { id:"inst-04", host:"aviaf-live-02", pid:4412,  account:"c3", config:"cfg-nq-orb",
    started:"2026-05-05 08:46 CT", uptime:"05h 40m", state:"degraded",
    cpu:6.1, mem:360, py:"3.11.7", branch:"main@a3f8c21", ticksPerSec:14, lagMs:118,
    strategies:["nq-orb-c3","mgc-alpha-c3"], heartbeat: gen_heartbeat(4) },
  { id:"inst-05", host:"aviaf-dev",     pid:7720,  account:null, config:"cfg-nq-orb",
    started:"2026-05-05 02:11 CT", uptime:"12h 15m", state:"stopped",
    cpu:0, mem:0, py:"3.11.7", branch:"feat/spc-v2@77c4d", ticksPerSec:0, lagMs:0,
    strategies:[], heartbeat: gen_heartbeat(5).map(()=>0) },
];

function gen_heartbeat(seed) {
  const out = []; let r = seed * 17 + 3;
  for (let i = 0; i < 60; i++) {
    r = (r * 9301 + 49297) % 233280;
    out.push(0.4 + (r/233280)*0.6);
  }
  return out;
}

window.OPEN_POSITIONS = {
  "inst-01": [
    { sym:"MGC.M26", side:"long", qty:2, entry:4598.10, mark:4612.30, unreal:+284.00, opened:"09:29:14", strat:"mgc-alpha-c1" },
    { sym:"NQ.M26",  side:"long", qty:1, entry:21477.50, mark:21485.25, unreal:+155.00, opened:"09:58:11", strat:"nq-orb-c1" },
  ],
  "inst-02": [
    { sym:"MGC.M26", side:"short", qty:2, entry:4615.40, mark:4619.10, unreal:-74.00, opened:"10:02:08", strat:"mgc-alpha-c2" },
  ],
  "inst-03": [],
  "inst-04": [
    { sym:"NQ.M26", side:"long", qty:1, entry:21512.00, mark:21498.75, unreal:-265.00, opened:"08:51:22", strat:"nq-orb-c3" },
  ],
  "inst-05": [],
};
/* per-account positions = positions of that account's instance */
window.positionsForAccount = function(acctId) {
  const a = window.ACCOUNTS.find(x=>x.id===acctId);
  return a ? (window.OPEN_POSITIONS[a.instance] || []) : [];
};

/* full TOML-style params on each runtime strategy */
window.STRATS.forEach(s => {
  if (s.type === "orb") {
    s.params = {
      orb: { opening_range_minutes:30, breakout_buffer_ticks:2, session_open_ct:"08:30", entry_window_minutes:90 },
      execution: { sl_atr_mult:1.0, tp_atr_mult:3.0, max_dollar_risk_per_trade:s.riskPerTrade, max_hold_hours:4.0, contracts:s.contracts },
      filters: { min_atr_pct:0.0008, max_daily_sl:2, daily_close_hour_ct:15 },
    };
  } else {
    s.params = {
      signal: { signal_mode:"trend", momentum_lookback:20, momentum_weight:0.55, alpha_threshold:0.015, entry_persistence_bars:2 },
      execution: { sl_pct:0.006, tp_pct:0.018, max_dollar_risk_per_trade:s.riskPerTrade, use_atr_sizing:true, contracts:s.contracts },
      filters: { rsi_upper:65, rsi_lower:35, max_daily_sl:2 },
    };
  }
});

/* RESEARCH — experiments produce / refine STRATEGY_DEFS */
window.RESEARCH = [
  { id:"r-001", title:"MGC Alpha — momentum lookback sweep", date:"2026-04-26", author:"k.s.", tag:"param-sweep",
    summary:"lookback ∈ [10..30], λ=0.3, embargo=5. Best E[R] +0.310 at lb=14. OOS degradation 41%.",
    status:"shipped", produces:["sd-mgc-alpha"] },
  { id:"r-002", title:"NQ ORB — opening range 15m vs 30m", date:"2026-04-22", author:"k.s.", tag:"ablation",
    summary:"15m gives more trades (1.4/day) but PF 1.34 < 30m PF 2.04. Stick with 30m.",
    status:"shipped", produces:["sd-nq-orb"] },
  { id:"r-003", title:"Combined MGC + NQ Monte Carlo (60 days)", date:"2026-04-02", author:"k.s.", tag:"monte-carlo",
    summary:"Best combo: MGC 1c + NQ 1c. P(pass) 77.8%, P(ruin) 73.8% over 60 days w/o early stop.",
    status:"shipped", produces:["sd-mgc-alpha","sd-nq-orb"] },
  { id:"r-004", title:"Volatility regime filter — ATR z-score", date:"2026-04-18", author:"k.s.", tag:"filter",
    summary:"Pause when ATR z>2. Improves E[R] +0.04 but cuts trade count 22%. Borderline.",
    status:"draft", produces:[] },
  { id:"r-005", title:"MGC Alpha — remove dead trend factor", date:"2026-04-15", author:"k.s.", tag:"ablation",
    summary:"Trend factor at dead_zone=0.5 contributes ≈0. Removing: no degradation, simpler model.",
    status:"shipped", produces:["sd-mgc-alpha"] },
  { id:"r-008", title:"Consecutive-SL cooldown", date:"2026-04-05", author:"k.s.", tag:"risk",
    summary:"Hard cap 2 SL/day stops April-2-style 7-loss streaks. Implemented in entry_filters.py.",
    status:"shipped", produces:["sd-mgc-alpha"] },
  { id:"r-009", title:"Live multi-account sizing — 3-5 accounts × 2c", date:"2026-04-28", author:"k.s.", tag:"scaling",
    summary:"Capital efficiency curve. Sweet spot: 4 accounts × 2c MGC. Drawdown corr ρ=0.62.",
    status:"draft", produces:[] },
];

/* market regime — what the live world is doing right now */
window.REGIME = {
  asOf:"2026-05-05 10:14 CT",
  symbols: [
    { sym:"MGC", venue:"COMEX", price:4612.30, atrPct:0.0142, atrZ:0.6, adx:24, trend:"up",
      regime:"trending", note:"ADX above 25 threshold — alpha-driven favored" },
    { sym:"NQ", venue:"CME", price:21485.25, atrPct:0.0091, atrZ:1.4, adx:18, trend:"up",
      regime:"breakout-prone", note:"ATR z>1, ADX<20 — ORB favored over alpha" },
    { sym:"ES", venue:"CME", price:5824.50, atrPct:0.0064, atrZ:-0.3, adx:14, trend:"flat",
      regime:"mean-reverting", note:"low ATR z, low ADX — neither strategy ideal" },
    { sym:"GC", venue:"COMEX", price:4615.20, atrPct:0.0145, atrZ:0.8, adx:26, trend:"up",
      regime:"trending", note:"mirrors MGC; consider full-size" },
  ],
};

/* LLM proposals — based on regime + research */
window.PROPOSALS = [
  { id:"p-001", kind:"new", date:"2026-05-04", strength:0.78,
    title:"Add NQ pullback-after-trend strategy",
    rationale:"NQ has shown 4 consecutive trending sessions (ADX>20) followed by 1-bar pullbacks averaging 0.4×ATR. Symmetric to ORB but different regime.",
    backtest:"E[R] +0.28 over 90d on 5m bars. PF 1.52. WR 51%. Drawdown corr with NQ ORB: ρ=0.31 (diversifies).",
    actions:["Open as research draft","Run param sweep"] },
  { id:"p-002", kind:"tune", date:"2026-05-04", strength:0.62, target:"sd-mgc-alpha",
    title:"Tighten MGC alpha threshold from 0.015 → 0.018",
    rationale:"Last 14 trading days: MGC trend factor saturating earlier (mean alpha at entry 0.022). Raising threshold filters marginal entries.",
    backtest:"Trade count −18%, E[R] +0.06. PF 1.68 → 1.81 on 30d backtest.",
    actions:["Apply to paper","Schedule A/B"] },
  { id:"p-003", kind:"tune", date:"2026-05-03", strength:0.55, target:"sd-nq-orb",
    title:"Pause NQ ORB on Wednesdays",
    rationale:"5 of last 7 losing days were Wednesdays. FOMC + EIA midweek noise. Already in MGC config; symmetry.",
    backtest:"Median DD −18%. P(pass) unchanged (78.4%).",
    actions:["Patch nq_5m_orb.toml","Open ablation"] },
  { id:"p-004", kind:"warn", date:"2026-05-05", strength:0.81, target:"sd-nq-orb",
    title:"NQ ORB · regime drift detected",
    rationale:"Last 10 sessions: ORB win rate 38% (baseline 52%). Open-range vol expansion shrinking — average breakout distance −24%.",
    backtest:"If regime persists, E[R] turns negative within 7 sessions. Recommend pause and re-research.",
    actions:["Pause c3","Open research note"] },
];

/* trades */
function makeTrades() {
  const out=[]; const symbols=["/MGC","/NQ"]; let r=12345;
  const rnd=()=>{r=(r*9301+49297)%233280;return r/233280;};
  const today=new Date(2026,4,5);
  for(let i=0;i<42;i++){
    const d=new Date(today);d.setDate(d.getDate()-Math.floor(i/1.6));
    const sym=symbols[Math.floor(rnd()*2)];
    const side=rnd()>0.45?"long":"short";
    const size=sym==="/NQ"?1:2;
    const entry=sym==="/NQ"?21000+rnd()*800:4500+rnd()*200;
    const exit=entry+(rnd()-0.45)*(sym==="/NQ"?70:30)*(side==="long"?1:-1);
    const mult=sym==="/NQ"?20:10;
    const pnl=(exit-entry)*mult*size*(side==="long"?1:-1);
    const dur=Math.floor(rnd()*240+5);
    const dh=String(Math.floor(dur/60)).padStart(2,"0");
    const dm=String(dur%60).padStart(2,"0");
    out.push({
      id:2543873000+i,
      account:["c1","c2","c3","x1"][Math.floor(rnd()*4)],
      symbol:sym, size, side,
      entryTime:new Date(d.getTime()-dur*60_000).toISOString(),
      exitTime:d.toISOString(),
      duration:`${dh}:${dm}:${String(Math.floor(rnd()*60)).padStart(2,"0")}`,
      entryPrice:+entry.toFixed(2),
      exitPrice:+exit.toFixed(2),
      pnl:+pnl.toFixed(2),
      commissions:-1.0*size,
      fees:-1.4*size,
      strategy:sym==="/NQ"?"NQ ORB 5m":"MGC Alpha 1h",
    });
  }
  return out.sort((a,b)=>new Date(b.exitTime)-new Date(a.exitTime));
}
window.TRADES = makeTrades();

// genEquity and the EQUITY_* mock series were removed 2026-05-20: every
// caller was rendering a deterministic-but-fabricated curve that the
// operator read as live P&L.  Real per-strategy / per-symbol equity
// lands via the hub /api/equity endpoint and the WS bridge in
// data-live.jsx.  Leaving this comment as a tombstone so anyone
// looking for the helper sees why it's gone.

window.SPC_ROWS = [
  { lbl:"MGC.alpha · c1", v:[1,2,1,3,2,1,1,2,1,1,2,3,2,1,1,1,2,1,1,2] },
  { lbl:"MGC.alpha · c2", v:[1,1,1,2,1,1,-1,1,1,1,1,2,1,1,-1,1,1,1,-1,1] },
  { lbl:"NQ.orb · c1",   v:[0,0,3,0,0,2,0,0,3,0,0,0,2,0,0,3,0,0,2,3] },
  { lbl:"NQ.orb · c3",   v:[0,1,-2,0,1,-1,0,-1,0,0,1,-1,-2,0,0,-1,0,-2,0,-1] },
  { lbl:"MGC.grind · x1",v:[1,1,1,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,1] },
];

window.FEED = [
  { t:"10:14:02", tag:"fill",   txt:"MGC sell 2c @ 4612.30 · TP · +$612 · c1" },
  { t:"10:11:48", tag:"signal", txt:"NQ.orb armed · breakout 21,485.25 · c1" },
  { t:"09:58:11", tag:"fill",   txt:"NQ buy 1c @ 21,477.50 · entry · c1" },
  { t:"09:42:30", tag:"risk",   txt:"c3 · NQ.orb paused — 2nd SL day cap reached" },
  { t:"09:31:00", tag:"sys",    txt:"session start · 4 instances scheduled · 1 paused" },
  { t:"09:29:14", tag:"fill",   txt:"MGC buy 2c @ 4598.10 · alpha+0.42 · c1" },
  { t:"09:14:55", tag:"signal", txt:"MGC.alpha · momentum z 1.84 · long persistence 2/2" },
  { t:"08:32:00", tag:"sys",    txt:"broker handshake ok · TopstepX latency 38ms" },
  { t:"08:14:09", tag:"sys",    txt:"MGC.alpha booted · ATR-sized 2c · risk $700" },
];

/* ── COLLECTORS · tick_recorder side ────────────────────────
   These are dedicated processes that capture market data into
   parquet/zstd shards. They are SEPARATE from the trading
   instances — the strategies read from this storage. */

function gen_tick_rate(seed){
  const out=[]; let r=seed*23+5;
  for(let i=0;i<60;i++){ r=(r*9301+49297)%233280; out.push(0.45+(r/233280)*0.55); }
  return out;
}

window.COLLECTORS = [
  { id:"col-cme-mbp", host:"aviaf-collect-01", pid:21044,
    venue:"CME", feed:"MBP-1 · ITCH-style", state:"recording",
    started:"2026-04-12 17:00 CT", uptime:"22d 17h 14m",
    symbols:["NQ.M26","NQ.U26","ES.M26","ES.U26","RTY.M26","6E.M26"],
    primarySymbol:"NQ.M26",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:14820, peakTps:38600, ticksToday:402_184_320,
    cpu:11.4, mem:1842, lagMs:6, gapsToday:0, gapsTotal:3,
    storage:{path:"/data/ticks/cme",  used:412.6, capacity:2048, format:"parquet+zstd-7", retention:"45d", shards:8412},
    quality:{coverage:0.9998, dupRate:0.00012, oosBars:0, lastBar:"10:14:02.118"},
    rate:gen_tick_rate(1) },
  { id:"col-comex-mbp", host:"aviaf-collect-01", pid:21088,
    venue:"COMEX", feed:"MBP-1", state:"recording",
    started:"2026-04-12 17:00 CT", uptime:"22d 17h 14m",
    symbols:["MGC.M26","MGC.Q26","GC.M26","SI.N26","HG.N26"],
    primarySymbol:"MGC.M26",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:6240, peakTps:18400, ticksToday:178_412_900,
    cpu:6.2, mem:1124, lagMs:8, gapsToday:0, gapsTotal:1,
    storage:{path:"/data/ticks/comex", used:188.4, capacity:1024, format:"parquet+zstd-7", retention:"45d", shards:5240},
    quality:{coverage:1.0000, dupRate:0.00009, oosBars:0, lastBar:"10:14:02.097"},
    rate:gen_tick_rate(2) },
  { id:"col-nymex-mbp", host:"aviaf-collect-01", pid:21102,
    venue:"NYMEX", feed:"MBP-1", state:"recording",
    started:"2026-04-12 17:00 CT", uptime:"22d 17h 14m",
    symbols:["CL.M26","NG.M26","RB.M26","HO.M26"],
    primarySymbol:"CL.M26",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:4180, peakTps:12200, ticksToday:114_280_000,
    cpu:4.1, mem:842, lagMs:9, gapsToday:0, gapsTotal:0,
    storage:{path:"/data/ticks/nymex", used:96.2, capacity:512, format:"parquet+zstd-7", retention:"45d", shards:2104},
    quality:{coverage:1.0000, dupRate:0.00007, oosBars:0, lastBar:"10:14:02.084"},
    rate:gen_tick_rate(3) },
  { id:"col-cbot-mbp", host:"aviaf-collect-02", pid:8221,
    venue:"CBOT", feed:"MBP-1", state:"degraded",
    started:"2026-05-04 22:11 CT", uptime:"12h 03m",
    symbols:["ZN.M26","ZB.M26","ZF.M26","ZC.N26","ZS.N26"],
    primarySymbol:"ZN.M26",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:1240, peakTps:5800, ticksToday:38_412_120,
    cpu:2.8, mem:524, lagMs:142, gapsToday:2, gapsTotal:14,
    storage:{path:"/data/ticks/cbot",  used:62.4, capacity:512, format:"parquet+zstd-7", retention:"45d", shards:1284},
    quality:{coverage:0.9962, dupRate:0.00018, oosBars:48, lastBar:"10:13:59.840"},
    rate:gen_tick_rate(4).map(v=>v*0.6) },
  { id:"col-cme-l2", host:"aviaf-collect-02", pid:8244,
    venue:"CME", feed:"MBP-10 · book", state:"recording",
    started:"2026-04-29 17:00 CT", uptime:"5d 17h 14m",
    symbols:["NQ.M26","ES.M26"],
    primarySymbol:"NQ.M26",
    py:"3.11.7", branch:"feat/book-ingest@b22e1",
    ticksPerSec:48200, peakTps:96400, ticksToday:1_282_412_000,
    cpu:18.4, mem:3284, lagMs:11, gapsToday:0, gapsTotal:0,
    storage:{path:"/data/book/cme",   used:284.0, capacity:1024, format:"parquet+zstd-3", retention:"7d",  shards:18420},
    quality:{coverage:0.9999, dupRate:0.00004, oosBars:0, lastBar:"10:14:02.121"},
    rate:gen_tick_rate(5).map(v=>0.7+v*0.3) },
  { id:"col-replay", host:"aviaf-dev", pid:14210,
    venue:"REPLAY", feed:"databento → parquet", state:"backfilling",
    started:"2026-05-05 03:11 CT", uptime:"07h 03m",
    symbols:["NQ.H24..M26","ES.H24..M26"],
    primarySymbol:"NQ historical",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:0, peakTps:0, ticksToday:0,
    cpu:22.1, mem:684, lagMs:0, gapsToday:0, gapsTotal:0,
    backfill:{from:"2024-03-01",to:"2026-05-01", progress:0.74, etaMin:108, gbProcessed:1820, gbTotal:2462},
    storage:{path:"/data/replay",     used:1820, capacity:4096, format:"parquet+zstd-9", retention:"forever", shards:0},
    quality:{coverage:0.9994, dupRate:0.00021, oosBars:212, lastBar:"2025-09-12 14:32 ET"},
    rate:gen_tick_rate(6).map(v=>0) },
  { id:"col-news",  host:"aviaf-collect-02", pid:8260,
    venue:"news",   feed:"benzinga · cme.gov · fed", state:"recording",
    started:"2026-04-12 17:00 CT", uptime:"22d 17h 14m",
    symbols:["macro","fomc","cpi","nfp","crude inv"],
    primarySymbol:"macro · all",
    py:"3.11.7", branch:"main@a3f8c21",
    ticksPerSec:2, peakTps:48, ticksToday:1_840,
    cpu:0.4, mem:128, lagMs:280, gapsToday:0, gapsTotal:0,
    storage:{path:"/data/news",       used:0.42, capacity:32, format:"jsonl+zstd-9", retention:"forever", shards:412},
    quality:{coverage:1.0000, dupRate:0.00200, oosBars:0, lastBar:"10:00:00.000"},
    rate:gen_tick_rate(7).map(v=>v*0.05) },
];

/* recent collector events — separate from trading feed */
window.COL_EVENTS = [
  { t:"10:14:02", col:"col-cme-mbp",   tag:"shard",  txt:"flushed shard #8412 · 12.4 MB · 142,820 ticks" },
  { t:"10:13:48", col:"col-cme-l2",    tag:"shard",  txt:"flushed L2 shard #18420 · 38.8 MB" },
  { t:"10:09:14", col:"col-cbot-mbp",  tag:"warn",   txt:"feed lag 142ms · ZN.M26 · degraded" },
  { t:"10:01:12", col:"col-cme-mbp",   tag:"sys",    txt:"NQ.U26 contract added to watchlist" },
  { t:"09:58:00", col:"col-comex-mbp", tag:"shard",  txt:"flushed shard #5240 · 8.1 MB" },
  { t:"09:42:30", col:"col-replay",    tag:"sys",    txt:"backfill progress 74% · ETA 108m" },
  { t:"09:31:00", col:"col-cme-mbp",   tag:"sys",    txt:"session open · ramp from 320 → 14,820 tps" },
  { t:"08:14:00", col:"col-cbot-mbp",  tag:"warn",   txt:"2 micro-gaps recovered via REPLAY" },
  { t:"04:00:00", col:"col-cme-mbp",   tag:"sys",    txt:"daily compaction: 8,412 shards → 412 partitions" },
  { t:"00:11:42", col:"col-news",      tag:"sys",    txt:"FOMC minutes ingested · 14 KB" },
];

/* aggregate storage roll-up */
window.STORAGE_ROLLUP = (() => {
  const used = window.COLLECTORS.reduce((s,c)=>s+c.storage.used,0);
  const cap  = window.COLLECTORS.reduce((s,c)=>s+c.storage.capacity,0);
  const tot  = window.COLLECTORS.reduce((s,c)=>s+(c.ticksToday||0),0);
  const tps  = window.COLLECTORS.reduce((s,c)=>s+c.ticksPerSec,0);
  return { used, cap, ticksToday: tot, tps };
})();

window.INSTANCE_LOGS = {
  "inst-01": [
    { t:"10:14:02.118", lvl:"INFO",  src:"strat.mgc-alpha", txt:"signal · z=1.84 · long persistence 2/2 · entered 2c @ 4598.10" },
    { t:"10:13:59.840", lvl:"INFO",  src:"broker.tsx",      txt:"order ack · MGC.M26 · BUY 2 · OID 88421" },
    { t:"10:11:48.221", lvl:"INFO",  src:"strat.nq-orb",    txt:"armed · break above 21,485.25 · ATR mult 1.0" },
    { t:"10:09:14.002", lvl:"DEBUG", src:"book.cme",        txt:"NQ.M26 spread 0.25 · queue 412×280 · imbalance −0.18" },
    { t:"09:58:11.504", lvl:"INFO",  src:"broker.tsx",      txt:"fill · NQ.M26 · BUY 1 @ 21,477.50" },
    { t:"09:42:30.118", lvl:"WARN",  src:"risk.guard",      txt:"c3 · 2nd SL day cap reached · pausing nq-orb-c3" },
    { t:"09:31:00.000", lvl:"INFO",  src:"sched",           txt:"session start · 4 strategies scheduled · 1 paused" },
    { t:"09:29:14.812", lvl:"INFO",  src:"broker.tsx",      txt:"fill · MGC.M26 · BUY 2 @ 4598.10 · slip 0.20" },
    { t:"09:14:55.330", lvl:"DEBUG", src:"strat.mgc-alpha", txt:"momentum z 1.84 · alpha 0.421 · trend 0.32 · rsi 58" },
    { t:"08:32:00.040", lvl:"INFO",  src:"broker.tsx",      txt:"handshake ok · UserHub · latency 38ms" },
    { t:"08:14:09.011", lvl:"INFO",  src:"boot",            txt:"mgc-alpha booted · ATR-sized 2c · risk $700 · max 2 SL/day" },
    { t:"08:14:09.000", lvl:"INFO",  src:"boot",            txt:"config cfg-combo loaded · 2 strategies · DLC $2,000" },
  ],
  "inst-02": [
    { t:"10:02:08.221", lvl:"INFO",  src:"broker.tsx",      txt:"fill · MGC.M26 · SELL 2 @ 4615.40" },
    { t:"10:00:02.118", lvl:"INFO",  src:"strat.mgc-alpha", txt:"signal · z=−1.62 · short persistence 2/2 · entered 2c @ 4615.40" },
    { t:"00:01:00.000", lvl:"INFO",  src:"sched",           txt:"globex session start · paper" },
    { t:"00:01:00.000", lvl:"INFO",  src:"boot",            txt:"mgc-alpha booted · paper · risk $700" },
  ],
  "inst-03": [
    { t:"09:42:11.804", lvl:"INFO",  src:"strat.mgc-grind", txt:"scratch exit · −$8 · neutral z" },
    { t:"08:51:22.000", lvl:"INFO",  src:"broker.tsx",      txt:"fill · MGC.M26 · BUY 1 @ 4602.10" },
    { t:"07:51:00.000", lvl:"INFO",  src:"boot",            txt:"mgc-grind booted · 1c · risk $350 · survival mode" },
  ],
  "inst-04": [
    { t:"10:09:14.002", lvl:"WARN",  src:"feed.cme",        txt:"lag 142ms sustained 90s · marking instance degraded" },
    { t:"09:42:30.118", lvl:"WARN",  src:"risk.guard",      txt:"c3 · 2nd SL day cap reached · pausing nq-orb-c3" },
    { t:"09:18:42.330", lvl:"INFO",  src:"broker.tsx",      txt:"fill · NQ.M26 · STOP-LOSS · −$1,575" },
    { t:"08:51:00.000", lvl:"INFO",  src:"broker.tsx",      txt:"fill · NQ.M26 · BUY 1 @ 21,512.00" },
    { t:"08:46:00.000", lvl:"INFO",  src:"boot",            txt:"nq-orb booted · 1c · ORB 30m" },
    { t:"08:46:00.000", lvl:"WARN",  src:"boot",            txt:"mgc-alpha attached but state=stopped · 0c" },
  ],
  "inst-05": [
    { t:"02:11:00.000", lvl:"INFO",  src:"boot",            txt:"dev instance · stopped state · feat/spc-v2" },
  ],
};
window.fmt$ = (n,frac=0)=>{const v=Number(n);if(!Number.isFinite(v))return"—";return(v<0?"−":"")+"$"+Math.abs(v).toLocaleString("en-US",{minimumFractionDigits:frac,maximumFractionDigits:frac});};
window.fmtP = (n,frac=2)=>{const v=Number(n);if(!Number.isFinite(v))return"—";return(v>=0?"+":"−")+Math.abs(v).toFixed(frac);};
window.pct = (n,frac=1)=>{const v=Number(n);if(!Number.isFinite(v))return"—";return(v>=0?"+":"−")+(Math.abs(v)*100).toFixed(frac)+"%";};
window.safeN = (n, fallback=0)=>{const v=Number(n);return Number.isFinite(v)?v:fallback;};
window.safeFix = (n, frac=2, dash="—")=>{const v=Number(n);return Number.isFinite(v)?v.toFixed(frac):dash;};
